import Vue from 'vue'

// import 'normalize.css/normalize.css' A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import { parseTime, addDateRange, download, downloadTemplate, buildTree, saveHandle, updateHandle, echoDictName, showErrorfocus, toolTip } from '@/utils'


// 全局组件挂载
Vue.prototype.addDateRange = addDateRange
Vue.prototype.parseTime = parseTime
Vue.prototype.download = download
Vue.prototype.downloadTemplate = downloadTemplate
Vue.prototype.buildTree = buildTree
Vue.prototype.saveHandle = saveHandle
Vue.prototype.updateHandle = updateHandle
Vue.prototype.echoDictName = echoDictName
Vue.prototype.showErrorfocus = showErrorfocus
Vue.prototype.toolTip = toolTip
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)

Vue.config.productionTip = false

// 注册全局指令 v-fade-in
Vue.directive('fade-in', {
  // 元素插入DOM时执行
  inserted(el) {
    // 初始状态：透明 + 上移
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 1.6s ease, transform 1.0s ease';

    // 创建Intersection Observer实例
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 元素进入视口：执行浮现动画
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
          // console.log('触发')
          // 只触发一次，之后取消监听
          observer.unobserve(el);
        }
      });
    }, {
      threshold: 0.1 // 元素10%进入视口时触发
    });

    // 开始监听当前元素
    observer.observe(el);
  }
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})